import { BREAKPOINTS } from '../constants';

/**
 * Find the first slide that overflows the left side of the slides container.
 * @param {object} slidesListPosition The BoundingClientRect of the slides list element.
 * @param {NodeList} slides All the slides nodes.
 * @return {Node} The first slide that overflows the left side of the container.
 */
export const findFirstOverflowedSlideFromLeft = (slidesListPosition, slides) => {
    let overflowedFromTheLeft;

    for (let i = slides.length - 1; i >= 0; i--) {
        const slideRect = slides[i].getBoundingClientRect();
        if (slidesListPosition.left > slideRect.left) {
            overflowedFromTheLeft = slideRect;
            break;
        }
    }
    return overflowedFromTheLeft;
};

/**
 * Find the first slide that overflows the right side of the slides container.
 * @param {object} slidesListPosition The BoundingClientRect of the slides list element.
 * @param {NodeList} slides All the slides nodes.
 * @return {Node} The first slide that overflows the left side of the container.
 */
export const findFirstOverflowedSlideFromRight = (slidesListPosition, slides) => {
    const result = Array.from(slides).find(
        (slide) => slidesListPosition.right < slide.getBoundingClientRect().right
    );

    return result?.getBoundingClientRect();
};

/**
 * Find the second slide inside the slides container.
 * @param {object} slidesListPosition The BoundingClientRect of the slides list element.
 * @param {NodeList} slides All the slides nodes.
 * @return {Node} The second slide inside the slides container.
 */
export const findSecondVisibleSlideFromTheLeft = (slidesListPosition, slides) => {
    const result = Array.from(slides).find(
        (slide) => slide.getBoundingClientRect().left > slidesListPosition.left
    );

    return result.getBoundingClientRect();
};

/**
 * Creates style object by iterating over the available breakpoints array.
 * For each breakpoint it checks if it has a value in the breakpoints prop or in larger breakpoint.
 * If nothing was found, breakpoint will be set to the value of slidesToShow prop.
 * @param {object} breakpoints Determines how many slides will be visible on each media query.
 * @param {object} slidesToShow The number of visible slides on default.
 * @return {object} style object with all the css variables representing the breakpoints.
 */
export const createCarouselBreakpoints = (breakpoints = {}, slidesToShow) => {
    const style = {};
    const breakpointsKeys = Object.keys(breakpoints);

    Object.values(BREAKPOINTS).forEach((bp) => {
        const breakpointKey = breakpointsKeys.find((breakpoint) => breakpoint >= bp);
        style[`--bp-${bp}`] = breakpoints[breakpointKey] || slidesToShow;
    });

    return style;
};

/**
     * Sets canScroll state according to carousel track position.
     * @param {boolean} isTrackOnPosition Is the carousel track on either the right or the left point.
     * @param {function} setCanScroll Set canScrollLeft or canScrollRight state.
     */
export const setCanScrollByPosition = (isTrackOnPosition, setCanScroll) => {
    if (isTrackOnPosition) {
        setCanScroll(false);
    } else {
        setCanScroll(true);
    }
};
